import styles from './styles';
import staticStyles from './staticStyles';

export { styles, staticStyles };
